export default __webpack_public_path__ + "static/media/noapp.bf534446.svg";